import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Avatar, Card, CardContent, CircularProgress, Grid, Typography } from '@material-ui/core';
import ListAltIcon from '@material-ui/icons/ListAlt';
import FormatListNumberedIcon from '@material-ui/icons/FormatListNumbered';
import CardActionArea from '@material-ui/core/CardActionArea';


const useStyles = makeStyles(theme => ({
  root: {
    borderRadius: 20,
    minHeight: 120,
    maxHeight: 120
  },
  title: {
    fontWeight: 700
  },
  avatar: {
    backgroundColor: theme.palette.info.main,
    height: 56,
    width: 56,
    zIndex: 1,
    marginRight: -50
  },
  icon: {
    height: 32,
    width: 32
  },
  difference: {
    marginTop: theme.spacing(1),
    display: 'flex',
    alignItems: 'center'
  },

  iconDiferencaPositivo: {
    color: theme.palette.success.dark
  },
  iconDiferencaNegativo: {
    color: theme.palette.error.dark,
  },
  valorDiferencaPositivo: {
    color: theme.palette.success.dark,
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1)
  },
  valorDiferencaNegativo: {
    color: theme.palette.error.dark,
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1)
  },
  cardContent: {
    zIndex: 1,
    marginTop: -90,
    marginRight: 25,
    display: 'flex',
    justifyContent: 'flex-end',
    cursor: 'pointer'
  },
  gridProgress: {
    display: 'flex',
    justifyContent: 'center'
  }

}));

const CardAnaliseGeral = props => {
  const { className, valorPrincipal, abrirAnalise, ...rest } = props;

  const classes = useStyles();
  const [qtdFiliadosGeral, setQtdFiliadosGeral] = useState();
  const [mostrarProgress, setMostrarProgress] = useState(false);
  const [mostrarAlertaErro, setMostrarAlertaErro] = useState(false);


  return (
    <Grid
      container
      style={{
        display:'flex',
        justifyContent: 'center',
        verticalAlign: 'middle'
      }}
    >
      <Grid
        item
        md={12}
        xs={12}
      >
        <Card
          {...rest}
          className={clsx(classes.root, className)}
          elevation={3}
        >
          <CardActionArea
            onClick={e => abrirAnalise()}
          >
            <CardContent
            >
              {
                mostrarProgress &&
                <Grid
                  container
                  md={12}
                  xs={12}
                >
                  <Grid
                    item
                    md={12}
                    xs={12}
                    className={clsx({
                      [classes.gridProgress]: true
                    })}
                  >
                    <CircularProgress/>
                  </Grid>
                </Grid>
              }
              {
                !mostrarProgress && !mostrarAlertaErro &&
                <Grid
                  container
                >
                  <Grid
                    item
                    md={12}
                    xs={12}

                  >
                    <Typography
                      className={classes.title}
                      color="textSecondary"
                      gutterBottom
                      variant="body2"
                    >
                      ANÁLISE GERAL
                    </Typography>

                  </Grid>
                  <Grid
                    item
                    md={12}
                    xs={12}
                    style={{
                      marginBottom: 10
                    }}
                  >
                    <Typography
                      variant="h4"
                    >
                      {`${valorPrincipal} movimentações`}
                    </Typography>
                  </Grid>
                  <FormatListNumberedIcon
                    fontSize={'small'}
                    className={clsx({
                      [classes.iconDiferencaPositivo]: true,
                    })}
                  />
                  <Typography
                    className={clsx({
                      [classes.valorDiferencaPositivo]: true,
                    })}
                    variant="body2"
                  >
                    Listagem de todas as movimentações
                  </Typography>

                </Grid>
              }
            </CardContent>
          </CardActionArea>

        </Card>
      </Grid>
      <Grid
        item
        md={12}
        xs={12}
        className={clsx({
          [classes.cardContent]: true
        })}
        onClick={e => abrirAnalise()}
      >
        <Avatar className={classes.avatar}>
          <ListAltIcon className={classes.icon} />
        </Avatar>
      </Grid>
    </Grid>
  );
};

CardAnaliseGeral.propTypes = {
  className: PropTypes.string
};

export default CardAnaliseGeral;
